import arrowDown from './icn-arrow-down.svg'
import arrowLeft from './icn-arrow-left.svg'
import arrowRight from './icn-arrow-right.svg'
import arrowUp from './icn-arrow-up.svg'
import back from './icn-back.svg'
import book from './icn-book.svg'
import brain from './icn-brain.svg'
import calendar from './icn-calendar.svg'
import check from './icn-check.svg'
import chevronDown from './icn-chevron-down.svg'
import chevronLeft from './icn-chevron-left.svg'
import chevronRight from './icn-chevron-right.svg'
import chevronUp from './icn-chevron-up.svg'
import clear from './icn-clear.svg'
import clipboard from './icn-clipboard.svg'
import close from './icn-close.svg'
import cogwheel from './icn-cogwheel.svg'
import collapseExpand from './icn-collapse-expand.svg'
import connections from './icn-connections.svg'
import contactSupport from './icn-contact-support.svg'
import copy from './icn-copy.svg'
import dangerCircle from './icn-danger-circle.svg'
import dangerCircleOutline from './icn-danger-circle-outline.svg'
import dashboard from './icn-dashboard.svg'
import decrease from './icn-decrease.svg'
import devPortal from './icn-dev-portal.svg'
import disabled from './icn-disabled.svg'
import document from './icn-document.svg'
import drag from './icn-drag.svg'
import errorFilled from './icn-error-filled.svg'
import expand from './icn-expand.svg'
import externalLink from './icn-external-link.svg'
import featureRequest from './icn-feature-request.svg'
import fileEmpty from './icn-file-empty.svg'
import fileJson from './icn-file-json.svg'
import fileMd from './icn-file-md.svg'
import fileYaml from './icn-file-yaml.svg'
import filter from './icn-filter.svg'
import flag from './icn-flag.svg'
import forward from './icn-forward.svg'
import gateway from './icn-gateway.svg'
import gear from './icn-gear.svg'
import gearFilled from './icn-gear-filled.svg'
import graduationHat from './icn-graduation-hat.svg'
import grid from './icn-grid.svg'
import handClock from './icn-hand-clock.svg'
import help from './icn-help.svg'
import immunity from './icn-immunity.svg'
import increase from './icn-increase.svg'
import info from './icn-info.svg'
import kong from './icn-kong.svg'
import lock from './icn-lock.svg'
import list from './icn-list.svg'
import more from './icn-more.svg'
import noData from './icn-no-data.svg'
import notificationBell from './icn-notification-bell.svg'
import notificationInbox from './icn-notification-inbox.svg'
import organization from './icn-organization.svg'
import plug from './icn-plug.svg'
import plus from './icn-plus.svg'
import organizations from './icn-organizations.svg'
import pencil from './icn-pencil.svg'
import people from './icn-people.svg'
import portal from './icn-portal.svg'
import profile from './icn-profile.svg'
import redo from './icn-redo.svg'
import runtimes from './icn-runtimes.svg'
import search from './icn-search.svg'
import security from './icn-security.svg'
import serviceDocument from './icn-service-document.svg'
import serviceHub from './icn-servicehub.svg'
import services from './icn-services.svg'
import sharedConfig from './icn-shared-config.svg'
import spinner from './icn-spinner.svg'
import stackedCards from './icn-stacked-cards.svg'
import stateConfigure from './icn-state-configure.svg'
import stateGruceo from './icn-state-gruceo.svg'
import stateNoData from './icn-state-no-data.svg'
import stateNoSearchResults from './icn-state-no-search-results.svg'
import stateUpload from './icn-state-upload.svg'
import support from './icn-support.svg'
import table from './icn-table.svg'
import team from './icn-team.svg'
import teamMember from './icn-team-member.svg'
import trash from './icn-trash.svg'
import vitals from './icn-vitals.svg'
import vitalsChart from './icn-vitals-chart.svg'
import warning from './icn-warning.svg'
import workspaces from './icn-workspaces.svg'
import workspacesCollapsed from './icn-collapse-workspaces.svg'

export default {
  arrowDown,
  arrowLeft,
  arrowRight,
  arrowUp,
  back,
  book,
  brain,
  calendar,
  check,
  chevronDown,
  chevronLeft,
  chevronRight,
  chevronUp,
  clear,
  clipboard,
  close,
  cogwheel,
  collapseExpand,
  connections,
  contactSupport,
  copy,
  dangerCircle,
  dangerCircleOutline,
  dashboard,
  decrease,
  devPortal,
  disabled,
  document,
  drag,
  errorFilled,
  expand,
  externalLink,
  featureRequest,
  fileEmpty,
  fileJson,
  fileMd,
  fileYaml,
  filter,
  flag,
  forward,
  gateway,
  gear,
  gearFilled,
  graduationHat,
  grid,
  handClock,
  help,
  immunity,
  increase,
  info,
  kong,
  list,
  lock,
  more,
  noData,
  notificationBell,
  notificationInbox,
  organization,
  organizations,
  pencil,
  people,
  portal,
  profile,
  redo,
  plug,
  plus,
  runtimes,
  search,
  security,
  serviceDocument,
  serviceHub,
  services,
  sharedConfig,
  spinner,
  stackedCards,
  support,
  table,
  team,
  teamMember,
  trash,
  vitals,
  vitalsChart,
  warning,
  workspaces,
  workspacesCollapsed,
  stateConfigure,
  stateGruceo,
  stateNoData,
  stateNoSearchResults,
  stateUpload
}
